import PageWrap from "@/components/PageWrap";
import { Box } from "@chakra-ui/react";
import Create from "./Create";
import Verify from "./Verify";
import { useHooks } from "./hooks";

const CreateAccount = () => {
  const {
    emailInput,
    setEmailInput,
    pwdInput,
    setPwdInput,
    rePwdInput,
    setRePwdInput,
    emailBtnStatus,
    phoneBtnStatus,
    CODE_BTN_STATUS,
    setEmailBtnStatus,
    setPhoneBtnStatus,
    emailBtnDisabled,
    phoneBtnDisabled,
    ADD_STEP,
    currStep,
    setCurrStep,
  } = useHooks();
  return (
    <PageWrap>
      <Box
        style={{ backgroundColor: "#fff" }}
        height={"auto"}
        minHeight={"100vh"}
        overflow={"hidden"}
        pt={"60px"}
      >
        {ADD_STEP.CREATE === currStep && (
          <Create
            emailInput={emailInput}
            setEmailInput={setEmailInput}
            pwdInput={pwdInput}
            setPwdInput={setPwdInput}
            rePwdInput={rePwdInput}
            setRePwdInput={setRePwdInput}
            setCurrStep={setCurrStep}
            ADD_STEP={ADD_STEP}
          />
        )}

        {ADD_STEP.VERIFY === currStep && (
          <Verify
            emailBtnDisabled={emailBtnDisabled}
            phoneBtnDisabled={phoneBtnDisabled}
            CODE_BTN_STATUS={CODE_BTN_STATUS}
            emailBtnStatus={emailBtnStatus}
            phoneBtnStatus={phoneBtnStatus}
            setEmailBtnStatus={setEmailBtnStatus}
            setPhoneBtnStatus={setPhoneBtnStatus}
            setCurrStep={setCurrStep}
            ADD_STEP={ADD_STEP}
            pwdInput={pwdInput}
            emailInput={emailInput}
          />
        )}
      </Box>
    </PageWrap>
  );
};

export default CreateAccount;
